import $date from '@/services/date'

export default function formatDate(
  date,
  format = 'll',
  allowedInputFormats = []
) {
  return allowedInputFormats?.length
    ? $date(date, allowedInputFormats, true).format(format)
    : $date(date).format(format)
}
